<template>
    <CustomerForm class="mt-12" @register-success="onRegisterSuccess" />
</template>
<script setup lang="ts">
import CustomerForm from '~/components/organisms/CustomerForm.vue';

const onRegisterSuccess = () => {
    const localRoute = useLocaleRoute()
    navigateTo(localRoute({ name: 'account' }))
}

definePageMeta({
    layout: 'shop'
})
</script>
